import map from 'lodash/map';
import pickBy from 'lodash/pickBy';
import { EElementType, ILandingElement } from '~/src/services/projects';
import { Header1 } from './Header1';
import { Header2 } from './Header2';
import { Grid, GridColumn } from './Grid';
import { Grid2, Grid2Column } from './Grid2';
import { Shift, ImageSection } from './Shift';
import { BgBlock } from './BgBlock';
import { Ligal, LigalColumn } from './Ligal';
import { Footer1 } from './Footer1';
import { Footer2 } from './Footer2';
import { Callback } from './Callback';
import { InfoBlock } from './InfoBlock';
import { TextBlock } from './TextBlock';
import { TariffCardsRA } from './TariffCardsRA';
import { Slider, SliderImage } from './Slider';
import { Carousel, CarouselImage } from './Carousel';
import { ImageGrid, ImageGridColumn } from './ImageGrid';
import { Accordion, AccordionTab } from './Accordion';
import { BlockSlider } from './BlockSlider';
import { BlockSliderNuka } from './BlockSliderNuka';
import { Tabs, TabColumn } from './Tabs';
import { ImageTextBlock } from './ImageTextBlock';
import { BlockGrid, BlockGridColumn } from '~/src/services/blocks/templates/BlockGrid';
import { Tariffs } from './Tariffs';

export interface IBlockType {
    label: string;
    value: string;
}

export interface IBlockTypes {
    [key: string]: ILandingElement;
}

const templates: IBlockTypes = {
    Header1,
    Header2,
    Grid,
    Grid2,
    Shift,
    BgBlock,
    Ligal,
    Footer1,
    Footer2,
    Callback,
    InfoBlock,
    TextBlock,
    Slider,
    ImageGrid,
    Tariffs,
    TariffCardsRA,
    Carousel,
    ImageTextBlock,
    Tabs,
    Accordion,
    BlockSlider,
    BlockSliderNuka,
    BlockGrid,
    column: GridColumn,
    headerColumn: Grid2Column,
    ligalColumn: LigalColumn,
    imageSection: ImageSection,
    sliderImage: SliderImage,
    carouselImage: CarouselImage,
    imageGridColumn: ImageGridColumn,
    tabColumn: TabColumn,
    accordionTab: AccordionTab,
    blockGridColumn: BlockGridColumn,
};

const HOST = process.env.NEXT_PUBLIC_CDN_HOST;
export const IMG_DOMAIN = HOST ? `${process.env.NEXT_PUBLIC_CDN_HOST}/landing-backend` : '';

export const blockTypes: IBlockType[] = map(
    pickBy(
        templates,
        template => template.type === EElementType.Block && template.isActive !== false,
    ),
    (template: ILandingElement) => ({
        label: template.label,
        value: template.title,
    }),
);

export default templates;
